import React from 'react';
import PropTypes from 'prop-types';

const Iphone01Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 4.00001H9.5M1 3V15C1 16.1046 1.89543 17 3 17H11C12.1046 17 13 16.1046 13 15V3.00001C13 1.89544 12.1046 1.00001 11 1.00001L3 1C1.89543 0.999998 1 1.89543 1 3ZM7 13H7.07084V13.0641H7V13Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Iphone01Icon.propTypes = {
  color: PropTypes.string,
};

export default Iphone01Icon;
